import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type ConfigurationsMicroFrontendProps = SpecificMicroFrontendProps;

export const ConfigurationsMicroFrontend: FC<ConfigurationsMicroFrontendProps> = ({
  entryPointUrl,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_CONFIGURATIONS_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      {...props}
    />
  );
};
